/*
 * @Author: wjc
 * @Date: 2026-03-24 11:07:20
 * @LastEditors: wjc
 * @LastEditTime: 2026-03-24 11:11:13
 * @Description:
 */
import type { Config } from '~/types'

export const appName = '绘管家物业云平台 - 智慧社区整体解决方案'
export const appDescription =
  '绘管家物业云平台为物业企业提供档案、收费、工单、巡检、智能硬件、移动 OA 与数据大屏能力，助力多项目统一管理、服务闭环和经营决策。'
export const apiBase = import.meta.env.VITE_API_URL

const config: Config = {
  websiteTitle: appName,
  footerWrite: {
    url: import.meta.env.VITE_INDEX_URL,
    adminUrl: import.meta.env.VITE_ADMIN_URL,
  },
  defaultSettings: {
    /**
     * @type String
     * @description Application's default title
     */
    title: '绘管家',

    /**
     * @type String
     * @description accessToken
     */
    cookieTokenName: 'wctm__',

    /**
     * @type String
     * @description refreshToken
     */
    cookieRefreshTokenName: 'wcRhtm__',

    /**
     * @type String
     * @description 当前登录企业 ID
     */
    enterpriseUserIdName: 'wcEnI__',

    /**
     * @type String
     * @description 当前登录uuid
     */
    uuidName: 'wcuutm__',

    /**
     * @type {boolean} true | false
     * @description Whether need tagsView
     */
    tagsView: true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: true,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    /**
     * @type {string | Array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: ['production', 'development'],
    fileUrl: '/yyds/file/download/',
  },
}

export default config
